import { type StateCreatorEnhance } from '@halo/zustand-enhance';
import { type User } from '@halo/chat-sdk';
import type { SessionStore } from './main';

export interface SingleStore {
  singleUser: User | undefined;
  initSingle: () => Promise<void>;
  updateSingleUser: (user: Partial<User>) => void;
  resolveSingleUser: () => Promise<void>;
}

export const singleStoreCreator: StateCreatorEnhance<SessionStore> = (set, get) =>
  ({
    singleUser: undefined,
    initSingle: async () => {
      const { resolveSingleUser } = get();
      await Promise.allSettled([resolveSingleUser()]);
    },
    updateSingleUser: (user) => {
      set((store) => {
        store.singleUser = Object.assign(store.singleUser || {}, user) as User;
      });
    },
    resolveSingleUser: async () => {
      const { client, session, effects, updateSingleUser } = get();
      if (client && session?.user_info?.user_id) {
        const { promise, removeListener } = client.Api.user.resolveUsersInfo(
          session.user_info.user_id,
          updateSingleUser
        );

        const { promise: promise2, removeListener: removeListener2 } =
          client.Api.user.getUserProfiles(session.user_info.user_id, updateSingleUser);

        effects.push(removeListener, removeListener2);
        await Promise.allSettled([promise, promise2]);
      }
    },
  }) as SessionStore;
